import editPageContent from "app/api/requests/PageContent/editPageContentRequest";
import getPageContentById from "app/api/requests/PageContent/getPageContentByIdRequest";
import getPageContent from "app/api/requests/PageContent/getPageContentRequest";
import getShortPageContent from "app/api/requests/PageContent/getShortPageContentRequest";
import uploadImg from "app/api/requests/PageContent/uploadImgRequest";
import deleteImg from "app/api/requests/PageContent/deleteImgRequest";
import addPageContent from "app/api/requests/PageContent/addPageContentRequest";
import delPageContent from "app/api/requests/PageContent/delPageContentRequest";

export default {
  editPageContent,
  getPageContentById,
  getPageContent,
  getShortPageContent,
  uploadImg,
  deleteImg,
  addPageContent,
  delPageContent
};
